import React from 'react';
import VehiculoItem from './VehiculoItem';

/**
 * Componente para mostrar una lista de vehículos con espaciado óptimo
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Array} props.vehiculos - Lista de vehículos a mostrar
 * @param {Array} props.categorias - Lista de categorías/tipos de vehículo disponibles
 * @param {function} props.onEdit - Función para editar un vehículo
 * @param {function} props.onDelete - Función para eliminar un vehículo
 * @param {function} props.onViewHistory - Función para ver el historial de mantenimientos
 * @returns {JSX.Element} - Componente de lista de vehículos
 */
const VehiculoList = ({ vehiculos = [], categorias = [], onEdit, onDelete, onViewHistory }) => {
  if (vehiculos.length === 0) {
    return (
      <div className="text-center p-4 bg-gray-800 rounded text-gray-400">
        No hay vehículos registrados. Agrega uno para comenzar.
      </div>
    );
  }

  return (
    <div>
      <ul className="mt-4 space-y-3">
        {vehiculos.map(vehiculo => (
          <VehiculoItem
            key={vehiculo.patente || vehiculo.Patente || vehiculo.id}
            vehiculo={vehiculo}
            categorias={categorias}
            onEdit={onEdit}
            onDelete={onDelete}
            onViewHistory={onViewHistory}
          />
        ))}
      </ul>
    </div>
  );
};

export default VehiculoList;